export const numberRenderer = (value) => {
  return parseFloat(value || 0).toFixed(2)
};

export const numberFieldWithPlaceholderRenderer = (value) => {
  if (!value) return '';
  return numberRenderer(value);
};
